// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/analytics.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { DateRange, Pagination, PaginationMeta, SortOrder } from "./common_pb.js";
import { DimensionFilter, MetricFilter, StatsRow } from "./reporting_pb.js";

/**
 * @generated from enum tracker.v1.TimeBucket
 */
export enum TimeBucket {
  /**
   * = DAY
   *
   * @generated from enum value: TIME_BUCKET_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TIME_BUCKET_HOUR = 1;
   */
  HOUR = 1,

  /**
   * @generated from enum value: TIME_BUCKET_DAY = 2;
   */
  DAY = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(TimeBucket)
proto3.util.setEnumType(TimeBucket, "tracker.v1.TimeBucket", [
  { no: 0, name: "TIME_BUCKET_UNSPECIFIED" },
  { no: 1, name: "TIME_BUCKET_HOUR" },
  { no: 2, name: "TIME_BUCKET_DAY" },
]);

/**
 * AttributionBasis selects which timestamp anchors conversion-side metrics.
 * LEAD_TIME (the default; UNSPECIFIED means it) puts a lead on the day it
 * ARRIVED (first_ts) and keeps it there whatever its status does later — an
 * approval a week on does not move the lead to that week. CONVERSION_TIME
 * («по дате конверсии») uses the time of the conversion's current status.
 * CLICK_TIME re-anchors onto the attributed click's timestamp so revenue lands
 * on the day the traffic was bought; rows without click_ts fall back to the
 * status time.
 *
 * @generated from enum tracker.v1.AttributionBasis
 */
export enum AttributionBasis {
  /**
   * @generated from enum value: ATTRIBUTION_BASIS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ATTRIBUTION_BASIS_CONVERSION_TIME = 1;
   */
  CONVERSION_TIME = 1,

  /**
   * @generated from enum value: ATTRIBUTION_BASIS_CLICK_TIME = 2;
   */
  CLICK_TIME = 2,

  /**
   * @generated from enum value: ATTRIBUTION_BASIS_LEAD_TIME = 3;
   */
  LEAD_TIME = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(AttributionBasis)
proto3.util.setEnumType(AttributionBasis, "tracker.v1.AttributionBasis", [
  { no: 0, name: "ATTRIBUTION_BASIS_UNSPECIFIED" },
  { no: 1, name: "ATTRIBUTION_BASIS_CONVERSION_TIME" },
  { no: 2, name: "ATTRIBUTION_BASIS_CLICK_TIME" },
  { no: 3, name: "ATTRIBUTION_BASIS_LEAD_TIME" },
]);

/**
 * ClickFunnelState signals whether click funnel analytics can be served.
 *
 * @generated from enum tracker.v1.ClickFunnelState
 */
export enum ClickFunnelState {
  /**
   * @generated from enum value: CLICK_FUNNEL_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Rows are available.
   *
   * @generated from enum value: CLICK_FUNNEL_STATE_AVAILABLE = 1;
   */
  AVAILABLE = 1,

  /**
   * Stream has no linked Keitaro campaign yet.
   *
   * @generated from enum value: CLICK_FUNNEL_STATE_NOT_PROVISIONED = 2;
   */
  NOT_PROVISIONED = 2,

  /**
   * Cross-database Keitaro view is missing or unreachable.
   *
   * @generated from enum value: CLICK_FUNNEL_STATE_UNAVAILABLE = 3;
   */
  UNAVAILABLE = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(ClickFunnelState)
proto3.util.setEnumType(ClickFunnelState, "tracker.v1.ClickFunnelState", [
  { no: 0, name: "CLICK_FUNNEL_STATE_UNSPECIFIED" },
  { no: 1, name: "CLICK_FUNNEL_STATE_AVAILABLE" },
  { no: 2, name: "CLICK_FUNNEL_STATE_NOT_PROVISIONED" },
  { no: 3, name: "CLICK_FUNNEL_STATE_UNAVAILABLE" },
]);

/**
 * Granularity for time-series rollups.
 *
 * @generated from enum tracker.v1.TimeSeriesGranularity
 */
export enum TimeSeriesGranularity {
  /**
   * @generated from enum value: TIME_SERIES_GRANULARITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TIME_SERIES_GRANULARITY_HOUR = 1;
   */
  HOUR = 1,

  /**
   * @generated from enum value: TIME_SERIES_GRANULARITY_DAY = 2;
   */
  DAY = 2,

  /**
   * @generated from enum value: TIME_SERIES_GRANULARITY_WEEK = 3;
   */
  WEEK = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(TimeSeriesGranularity)
proto3.util.setEnumType(TimeSeriesGranularity, "tracker.v1.TimeSeriesGranularity", [
  { no: 0, name: "TIME_SERIES_GRANULARITY_UNSPECIFIED" },
  { no: 1, name: "TIME_SERIES_GRANULARITY_HOUR" },
  { no: 2, name: "TIME_SERIES_GRANULARITY_DAY" },
  { no: 3, name: "TIME_SERIES_GRANULARITY_WEEK" },
]);

/**
 * @generated from message tracker.v1.ClicksByMinuteRequest
 */
export class ClicksByMinuteRequest extends Message<ClicksByMinuteRequest> {
  /**
   * @generated from field: repeated string campaign_ids = 1;
   */
  campaignIds: string[] = [];

  /**
   * [from, to) as RFC 3339 instants; at most 7 days apart.
   *
   * @generated from field: string from = 2;
   */
  from = "";

  /**
   * @generated from field: string to = 3;
   */
  to = "";

  constructor(data?: PartialMessage<ClicksByMinuteRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ClicksByMinuteRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClicksByMinuteRequest {
    return new ClicksByMinuteRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClicksByMinuteRequest {
    return new ClicksByMinuteRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClicksByMinuteRequest {
    return new ClicksByMinuteRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ClicksByMinuteRequest | PlainMessage<ClicksByMinuteRequest> | undefined, b: ClicksByMinuteRequest | PlainMessage<ClicksByMinuteRequest> | undefined): boolean {
    return proto3.util.equals(ClicksByMinuteRequest, a, b);
  }
}

/**
 * One minute of one campaign from one network in one class. Minutes with no
 * clicks are absent; the client fills the gaps.
 *
 * @generated from message tracker.v1.ClicksByMinuteRow
 */
export class ClicksByMinuteRow extends Message<ClicksByMinuteRow> {
  /**
   * @generated from field: string campaign_id = 1;
   */
  campaignId = "";

  /**
   * RFC 3339, UTC, the start of the minute.
   *
   * @generated from field: string minute = 2;
   */
  minute = "";

  /**
   * The carrying autonomous system (0 = not observed) and its name as the
   * click carried it.
   *
   * @generated from field: uint32 asn = 3;
   */
  asn = 0;

  /**
   * @generated from field: string as_org = 4;
   */
  asOrg = "";

  /**
   * bot | suspect | human: bot = the click's traffic class is not human
   * (bot_flag = 1); suspect = human class with a provider bot score ≥ 70
   * (the board's «бот-скор выше 0,7»); human = the rest.
   *
   * @generated from field: string bot_class = 5;
   */
  botClass = "";

  /**
   * Distinct clicks and distinct addresses.
   *
   * @generated from field: uint64 clicks = 6;
   */
  clicks = protoInt64.zero;

  /**
   * @generated from field: uint64 unique_ips = 7;
   */
  uniqueIps = protoInt64.zero;

  /**
   * Of those clicks, the ones a network filter answered with the stub or a
   * refusal instead of the landing.
   *
   * @generated from field: uint64 filtered = 8;
   */
  filtered = protoInt64.zero;

  constructor(data?: PartialMessage<ClicksByMinuteRow>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ClicksByMinuteRow";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "minute", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "asn", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "as_org", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "bot_class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "clicks", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 7, name: "unique_ips", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 8, name: "filtered", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClicksByMinuteRow {
    return new ClicksByMinuteRow().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClicksByMinuteRow {
    return new ClicksByMinuteRow().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClicksByMinuteRow {
    return new ClicksByMinuteRow().fromJsonString(jsonString, options);
  }

  static equals(a: ClicksByMinuteRow | PlainMessage<ClicksByMinuteRow> | undefined, b: ClicksByMinuteRow | PlainMessage<ClicksByMinuteRow> | undefined): boolean {
    return proto3.util.equals(ClicksByMinuteRow, a, b);
  }
}

/**
 * @generated from message tracker.v1.ClicksByMinuteResponse
 */
export class ClicksByMinuteResponse extends Message<ClicksByMinuteResponse> {
  /**
   * @generated from field: repeated tracker.v1.ClicksByMinuteRow rows = 1;
   */
  rows: ClicksByMinuteRow[] = [];

  constructor(data?: PartialMessage<ClicksByMinuteResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ClicksByMinuteResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rows", kind: "message", T: ClicksByMinuteRow, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClicksByMinuteResponse {
    return new ClicksByMinuteResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClicksByMinuteResponse {
    return new ClicksByMinuteResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClicksByMinuteResponse {
    return new ClicksByMinuteResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ClicksByMinuteResponse | PlainMessage<ClicksByMinuteResponse> | undefined, b: ClicksByMinuteResponse | PlainMessage<ClicksByMinuteResponse> | undefined): boolean {
    return proto3.util.equals(ClicksByMinuteResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.TimeOnPageRequest
 */
export class TimeOnPageRequest extends Message<TimeOnPageRequest> {
  /**
   * @generated from field: repeated string campaign_ids = 1;
   */
  campaignIds: string[] = [];

  /**
   * [from, to) as RFC 3339 instants (click time); at most 31 days apart.
   *
   * @generated from field: string from = 2;
   */
  from = "";

  /**
   * @generated from field: string to = 3;
   */
  to = "";

  /**
   * @generated from field: tracker.v1.TimeBucket bucket = 4;
   */
  bucket = TimeBucket.UNSPECIFIED;

  /**
   * IANA zone the buckets are cut in; empty = the workspace's timezone.
   *
   * @generated from field: string timezone = 5;
   */
  timezone = "";

  constructor(data?: PartialMessage<TimeOnPageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TimeOnPageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "bucket", kind: "enum", T: proto3.getEnumType(TimeBucket) },
    { no: 5, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TimeOnPageRequest {
    return new TimeOnPageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TimeOnPageRequest {
    return new TimeOnPageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TimeOnPageRequest {
    return new TimeOnPageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: TimeOnPageRequest | PlainMessage<TimeOnPageRequest> | undefined, b: TimeOnPageRequest | PlainMessage<TimeOnPageRequest> | undefined): boolean {
    return proto3.util.equals(TimeOnPageRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.TimeOnPageRow
 */
export class TimeOnPageRow extends Message<TimeOnPageRow> {
  /**
   * @generated from field: string campaign_id = 1;
   */
  campaignId = "";

  /**
   * RFC 3339 start of the bucket in the request's zone.
   *
   * @generated from field: string bucket_start = 2;
   */
  bucketStart = "";

  /**
   * Sessions of the campaign's clicks that beaconed at least once.
   *
   * @generated from field: uint64 sessions = 3;
   */
  sessions = protoInt64.zero;

  /**
   * Seconds between the session's first and last event.
   *
   * @generated from field: double p25_seconds = 4;
   */
  p25Seconds = 0;

  /**
   * @generated from field: double median_seconds = 5;
   */
  medianSeconds = 0;

  /**
   * @generated from field: double p75_seconds = 6;
   */
  p75Seconds = 0;

  /**
   * Share of sessions shorter than 3 seconds (a page loaded and left).
   *
   * @generated from field: double left_under_3s_share = 7;
   */
  leftUnder3sShare = 0;

  constructor(data?: PartialMessage<TimeOnPageRow>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TimeOnPageRow";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "bucket_start", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sessions", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "p25_seconds", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "median_seconds", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "p75_seconds", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "left_under_3s_share", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TimeOnPageRow {
    return new TimeOnPageRow().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TimeOnPageRow {
    return new TimeOnPageRow().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TimeOnPageRow {
    return new TimeOnPageRow().fromJsonString(jsonString, options);
  }

  static equals(a: TimeOnPageRow | PlainMessage<TimeOnPageRow> | undefined, b: TimeOnPageRow | PlainMessage<TimeOnPageRow> | undefined): boolean {
    return proto3.util.equals(TimeOnPageRow, a, b);
  }
}

/**
 * @generated from message tracker.v1.TimeOnPageResponse
 */
export class TimeOnPageResponse extends Message<TimeOnPageResponse> {
  /**
   * @generated from field: repeated tracker.v1.TimeOnPageRow rows = 1;
   */
  rows: TimeOnPageRow[] = [];

  constructor(data?: PartialMessage<TimeOnPageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TimeOnPageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rows", kind: "message", T: TimeOnPageRow, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TimeOnPageResponse {
    return new TimeOnPageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TimeOnPageResponse {
    return new TimeOnPageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TimeOnPageResponse {
    return new TimeOnPageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: TimeOnPageResponse | PlainMessage<TimeOnPageResponse> | undefined, b: TimeOnPageResponse | PlainMessage<TimeOnPageResponse> | undefined): boolean {
    return proto3.util.equals(TimeOnPageResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetGeoEfficiencyRequest
 */
export class GetGeoEfficiencyRequest extends Message<GetGeoEfficiencyRequest> {
  /**
   * @generated from field: repeated string stream_ids = 1;
   */
  streamIds: string[] = [];

  /**
   * @generated from field: tracker.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * ISO-3166-1 alpha-2, as stored on the click row.
   *
   * @generated from field: string country = 3;
   */
  country = "";

  constructor(data?: PartialMessage<GetGeoEfficiencyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetGeoEfficiencyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stream_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
    { no: 3, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGeoEfficiencyRequest {
    return new GetGeoEfficiencyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGeoEfficiencyRequest {
    return new GetGeoEfficiencyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGeoEfficiencyRequest {
    return new GetGeoEfficiencyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetGeoEfficiencyRequest | PlainMessage<GetGeoEfficiencyRequest> | undefined, b: GetGeoEfficiencyRequest | PlainMessage<GetGeoEfficiencyRequest> | undefined): boolean {
    return proto3.util.equals(GetGeoEfficiencyRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetGeoEfficiencyResponse
 */
export class GetGeoEfficiencyResponse extends Message<GetGeoEfficiencyResponse> {
  /**
   * @generated from field: string country = 1;
   */
  country = "";

  /**
   * IANA zone the grid is drawn in — the country's own, not the report's.
   *
   * @generated from field: string timezone = 2;
   */
  timezone = "";

  /**
   * False when the country had no zone and the grid fell back to UTC. Reading
   * an hour-of-day chart without knowing that is worse than not drawing it.
   *
   * @generated from field: bool timezone_known = 3;
   */
  timezoneKnown = false;

  /**
   * @generated from field: repeated tracker.v1.GeoEfficiencyCell cells = 4;
   */
  cells: GeoEfficiencyCell[] = [];

  constructor(data?: PartialMessage<GetGeoEfficiencyResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetGeoEfficiencyResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "timezone_known", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "cells", kind: "message", T: GeoEfficiencyCell, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGeoEfficiencyResponse {
    return new GetGeoEfficiencyResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGeoEfficiencyResponse {
    return new GetGeoEfficiencyResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGeoEfficiencyResponse {
    return new GetGeoEfficiencyResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetGeoEfficiencyResponse | PlainMessage<GetGeoEfficiencyResponse> | undefined, b: GetGeoEfficiencyResponse | PlainMessage<GetGeoEfficiencyResponse> | undefined): boolean {
    return proto3.util.equals(GetGeoEfficiencyResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GeoEfficiencyCell
 */
export class GeoEfficiencyCell extends Message<GeoEfficiencyCell> {
  /**
   * 1 = Monday … 7 = Sunday, matching ClickHouse toDayOfWeek.
   *
   * @generated from field: int32 weekday = 1;
   */
  weekday = 0;

  /**
   * @generated from field: int32 hour = 2;
   */
  hour = 0;

  /**
   * @generated from field: int64 clicks = 3;
   */
  clicks = protoInt64.zero;

  /**
   * @generated from field: int64 conversions = 4;
   */
  conversions = protoInt64.zero;

  /**
   * @generated from field: string revenue = 5;
   */
  revenue = "";

  constructor(data?: PartialMessage<GeoEfficiencyCell>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GeoEfficiencyCell";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "weekday", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "hour", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "clicks", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "conversions", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "revenue", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GeoEfficiencyCell {
    return new GeoEfficiencyCell().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GeoEfficiencyCell {
    return new GeoEfficiencyCell().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GeoEfficiencyCell {
    return new GeoEfficiencyCell().fromJsonString(jsonString, options);
  }

  static equals(a: GeoEfficiencyCell | PlainMessage<GeoEfficiencyCell> | undefined, b: GeoEfficiencyCell | PlainMessage<GeoEfficiencyCell> | undefined): boolean {
    return proto3.util.equals(GeoEfficiencyCell, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetGeoInsightsRequest
 */
export class GetGeoInsightsRequest extends Message<GetGeoInsightsRequest> {
  /**
   * @generated from field: repeated string stream_ids = 1;
   */
  streamIds: string[] = [];

  /**
   * @generated from field: tracker.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * @generated from field: string country = 3;
   */
  country = "";

  constructor(data?: PartialMessage<GetGeoInsightsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetGeoInsightsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stream_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
    { no: 3, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGeoInsightsRequest {
    return new GetGeoInsightsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGeoInsightsRequest {
    return new GetGeoInsightsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGeoInsightsRequest {
    return new GetGeoInsightsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetGeoInsightsRequest | PlainMessage<GetGeoInsightsRequest> | undefined, b: GetGeoInsightsRequest | PlainMessage<GetGeoInsightsRequest> | undefined): boolean {
    return proto3.util.equals(GetGeoInsightsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetGeoInsightsResponse
 */
export class GetGeoInsightsResponse extends Message<GetGeoInsightsResponse> {
  /**
   * @generated from field: string country = 1;
   */
  country = "";

  /**
   * @generated from field: int64 clicks = 2;
   */
  clicks = protoInt64.zero;

  /**
   * @generated from field: repeated tracker.v1.GeoGoalInsight goals = 3;
   */
  goals: GeoGoalInsight[] = [];

  /**
   * @generated from field: tracker.v1.GeoForecast forecast = 4;
   */
  forecast?: GeoForecast;

  constructor(data?: PartialMessage<GetGeoInsightsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetGeoInsightsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "clicks", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "goals", kind: "message", T: GeoGoalInsight, repeated: true },
    { no: 4, name: "forecast", kind: "message", T: GeoForecast },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGeoInsightsResponse {
    return new GetGeoInsightsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGeoInsightsResponse {
    return new GetGeoInsightsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGeoInsightsResponse {
    return new GetGeoInsightsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetGeoInsightsResponse | PlainMessage<GetGeoInsightsResponse> | undefined, b: GetGeoInsightsResponse | PlainMessage<GetGeoInsightsResponse> | undefined): boolean {
    return proto3.util.equals(GetGeoInsightsResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GeoGoalInsight
 */
export class GeoGoalInsight extends Message<GeoGoalInsight> {
  /**
   * @generated from field: string goal_key = 1;
   */
  goalKey = "";

  /**
   * @generated from field: int64 approved = 2;
   */
  approved = protoInt64.zero;

  /**
   * @generated from field: int64 hold = 3;
   */
  hold = protoInt64.zero;

  /**
   * @generated from field: string revenue = 4;
   */
  revenue = "";

  /**
   * @generated from field: double conversion_rate = 5;
   */
  conversionRate = 0;

  /**
   * Measured from the CLICK: how long before the traffic's verdict is in.
   *
   * @generated from field: int64 median_lag_minutes = 6;
   */
  medianLagMinutes = protoInt64.zero;

  /**
   * @generated from field: int64 p90_lag_minutes = 7;
   */
  p90LagMinutes = protoInt64.zero;

  constructor(data?: PartialMessage<GeoGoalInsight>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GeoGoalInsight";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "goal_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "approved", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "hold", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "revenue", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "conversion_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "median_lag_minutes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "p90_lag_minutes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GeoGoalInsight {
    return new GeoGoalInsight().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GeoGoalInsight {
    return new GeoGoalInsight().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GeoGoalInsight {
    return new GeoGoalInsight().fromJsonString(jsonString, options);
  }

  static equals(a: GeoGoalInsight | PlainMessage<GeoGoalInsight> | undefined, b: GeoGoalInsight | PlainMessage<GeoGoalInsight> | undefined): boolean {
    return proto3.util.equals(GeoGoalInsight, a, b);
  }
}

/**
 * GeoForecast is an estimate, not a promise: it assumes recent clicks convert
 * like the sample below them did. sample_clicks / sample_conversions travel
 * with it so a reader can see how much history it rests on — a forecast from
 * eleven conversions is a guess and should be shown as one. Zero
 * sample_conversions means no forecast was possible, NOT that none are
 * expected.
 *
 * @generated from message tracker.v1.GeoForecast
 */
export class GeoForecast extends Message<GeoForecast> {
  /**
   * @generated from field: double expected_conversions = 1;
   */
  expectedConversions = 0;

  /**
   * @generated from field: int64 pending_clicks = 2;
   */
  pendingClicks = protoInt64.zero;

  /**
   * @generated from field: double base_rate = 3;
   */
  baseRate = 0;

  /**
   * @generated from field: int64 sample_clicks = 4;
   */
  sampleClicks = protoInt64.zero;

  /**
   * @generated from field: int64 sample_conversions = 5;
   */
  sampleConversions = protoInt64.zero;

  constructor(data?: PartialMessage<GeoForecast>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GeoForecast";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "expected_conversions", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "pending_clicks", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "base_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "sample_clicks", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "sample_conversions", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GeoForecast {
    return new GeoForecast().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GeoForecast {
    return new GeoForecast().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GeoForecast {
    return new GeoForecast().fromJsonString(jsonString, options);
  }

  static equals(a: GeoForecast | PlainMessage<GeoForecast> | undefined, b: GeoForecast | PlainMessage<GeoForecast> | undefined): boolean {
    return proto3.util.equals(GeoForecast, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetCampaignFunnelRequest
 */
export class GetCampaignFunnelRequest extends Message<GetCampaignFunnelRequest> {
  /**
   * @generated from field: string campaign_id = 1;
   */
  campaignId = "";

  /**
   * @generated from field: tracker.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  constructor(data?: PartialMessage<GetCampaignFunnelRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetCampaignFunnelRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCampaignFunnelRequest {
    return new GetCampaignFunnelRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCampaignFunnelRequest {
    return new GetCampaignFunnelRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCampaignFunnelRequest {
    return new GetCampaignFunnelRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCampaignFunnelRequest | PlainMessage<GetCampaignFunnelRequest> | undefined, b: GetCampaignFunnelRequest | PlainMessage<GetCampaignFunnelRequest> | undefined): boolean {
    return proto3.util.equals(GetCampaignFunnelRequest, a, b);
  }
}

/**
 * CampaignFunnelStep is one served-document step in the campaign funnel. Steps
 * are ordered by step_index; a monetisation branch's documents appear as their
 * own steps carrying the branch's trigger.
 *
 * @generated from message tracker.v1.CampaignFunnelStep
 */
export class CampaignFunnelStep extends Message<CampaignFunnelStep> {
  /**
   * @generated from field: uint32 step_index = 1;
   */
  stepIndex = 0;

  /**
   * role labels the step: prelander | landing | thankyou (or "branch" for a
   * monetisation branch's document). Sourced from flow_nodes.lander_role.
   *
   * @generated from field: string role = 2;
   */
  role = "";

  /**
   * @generated from field: string node_id = 3;
   */
  nodeId = "";

  /**
   * @generated from field: string lander_id = 4;
   */
  landerId = "";

  /**
   * views counts step_views rows for this step; unique_views counts distinct
   * visitors (is_unique = 1).
   *
   * @generated from field: int64 views = 5;
   */
  views = protoInt64.zero;

  /**
   * @generated from field: int64 unique_views = 6;
   */
  uniqueViews = protoInt64.zero;

  /**
   * @generated from field: bool is_rotation_reroll = 8;
   */
  isRotationReroll = false;

  /**
   * branch is the trigger of the monetisation branch this document was served
   * in (back | exit_intent | idle | scroll_end); "" on the ad-click journey.
   *
   * @generated from field: string branch = 9;
   */
  branch = "";

  constructor(data?: PartialMessage<CampaignFunnelStep>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CampaignFunnelStep";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "step_index", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "node_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "lander_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "views", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "unique_views", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "is_rotation_reroll", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "branch", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CampaignFunnelStep {
    return new CampaignFunnelStep().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CampaignFunnelStep {
    return new CampaignFunnelStep().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CampaignFunnelStep {
    return new CampaignFunnelStep().fromJsonString(jsonString, options);
  }

  static equals(a: CampaignFunnelStep | PlainMessage<CampaignFunnelStep> | undefined, b: CampaignFunnelStep | PlainMessage<CampaignFunnelStep> | undefined): boolean {
    return proto3.util.equals(CampaignFunnelStep, a, b);
  }
}

/**
 * LanderDistributionRow is one lander's share of the campaign's served traffic,
 * including each branch's landers (branch = its trigger).
 *
 * @generated from message tracker.v1.LanderDistributionRow
 */
export class LanderDistributionRow extends Message<LanderDistributionRow> {
  /**
   * @generated from field: string lander_id = 1;
   */
  landerId = "";

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId = "";

  /**
   * @generated from field: int64 views = 3;
   */
  views = protoInt64.zero;

  /**
   * @generated from field: int64 unique_views = 4;
   */
  uniqueViews = protoInt64.zero;

  /**
   * @generated from field: string branch = 6;
   */
  branch = "";

  constructor(data?: PartialMessage<LanderDistributionRow>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.LanderDistributionRow";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "lander_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "node_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "views", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "unique_views", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "branch", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LanderDistributionRow {
    return new LanderDistributionRow().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LanderDistributionRow {
    return new LanderDistributionRow().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LanderDistributionRow {
    return new LanderDistributionRow().fromJsonString(jsonString, options);
  }

  static equals(a: LanderDistributionRow | PlainMessage<LanderDistributionRow> | undefined, b: LanderDistributionRow | PlainMessage<LanderDistributionRow> | undefined): boolean {
    return proto3.util.equals(LanderDistributionRow, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetCampaignFunnelResponse
 */
export class GetCampaignFunnelResponse extends Message<GetCampaignFunnelResponse> {
  /**
   * entry_visits is the count of entry documents served (step_index 0).
   *
   * @generated from field: int64 entry_visits = 1;
   */
  entryVisits = protoInt64.zero;

  /**
   * steps is the ordered funnel by step_index, monetisation branches included.
   *
   * @generated from field: repeated tracker.v1.CampaignFunnelStep steps = 2;
   */
  steps: CampaignFunnelStep[] = [];

  /**
   * cta_clicks counts lander CTA click-throughs (tracker.lp_clicks).
   *
   * @generated from field: int64 cta_clicks = 3;
   */
  ctaClicks = protoInt64.zero;

  /**
   * offer_visits counts clicks that reached an OFFER terminal (tracker.clicks).
   *
   * @generated from field: int64 offer_visits = 4;
   */
  offerVisits = protoInt64.zero;

  /**
   * conversions counts attributed APPROVED conversions (tracker.conversions_current).
   *
   * @generated from field: int64 conversions = 5;
   */
  conversions = protoInt64.zero;

  /**
   * lander_distribution is the per-lander view breakdown (incl. branches).
   *
   * @generated from field: repeated tracker.v1.LanderDistributionRow lander_distribution = 6;
   */
  landerDistribution: LanderDistributionRow[] = [];

  constructor(data?: PartialMessage<GetCampaignFunnelResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetCampaignFunnelResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entry_visits", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "steps", kind: "message", T: CampaignFunnelStep, repeated: true },
    { no: 3, name: "cta_clicks", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "offer_visits", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "conversions", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "lander_distribution", kind: "message", T: LanderDistributionRow, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCampaignFunnelResponse {
    return new GetCampaignFunnelResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCampaignFunnelResponse {
    return new GetCampaignFunnelResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCampaignFunnelResponse {
    return new GetCampaignFunnelResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCampaignFunnelResponse | PlainMessage<GetCampaignFunnelResponse> | undefined, b: GetCampaignFunnelResponse | PlainMessage<GetCampaignFunnelResponse> | undefined): boolean {
    return proto3.util.equals(GetCampaignFunnelResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.StreamStatsRow
 */
export class StreamStatsRow extends Message<StreamStatsRow> {
  /**
   * @generated from field: string stream_id = 1;
   */
  streamId = "";

  /**
   * @generated from field: string stream_name = 2;
   */
  streamName = "";

  /**
   * @generated from field: tracker.v1.StatsRow stats = 3;
   */
  stats?: StatsRow;

  constructor(data?: PartialMessage<StreamStatsRow>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.StreamStatsRow";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stream_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stream_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "stats", kind: "message", T: StatsRow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StreamStatsRow {
    return new StreamStatsRow().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StreamStatsRow {
    return new StreamStatsRow().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StreamStatsRow {
    return new StreamStatsRow().fromJsonString(jsonString, options);
  }

  static equals(a: StreamStatsRow | PlainMessage<StreamStatsRow> | undefined, b: StreamStatsRow | PlainMessage<StreamStatsRow> | undefined): boolean {
    return proto3.util.equals(StreamStatsRow, a, b);
  }
}

/**
 * @generated from message tracker.v1.BreakdownRow
 */
export class BreakdownRow extends Message<BreakdownRow> {
  /**
   * @generated from field: string dimension_value = 1;
   */
  dimensionValue = "";

  /**
   * @generated from field: string dimension_name = 2;
   */
  dimensionName = "";

  /**
   * @generated from field: tracker.v1.StatsRow stats = 3;
   */
  stats?: StatsRow;

  constructor(data?: PartialMessage<BreakdownRow>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.BreakdownRow";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dimension_value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dimension_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "stats", kind: "message", T: StatsRow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BreakdownRow {
    return new BreakdownRow().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BreakdownRow {
    return new BreakdownRow().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BreakdownRow {
    return new BreakdownRow().fromJsonString(jsonString, options);
  }

  static equals(a: BreakdownRow | PlainMessage<BreakdownRow> | undefined, b: BreakdownRow | PlainMessage<BreakdownRow> | undefined): boolean {
    return proto3.util.equals(BreakdownRow, a, b);
  }
}

/**
 * @generated from message tracker.v1.TimeSeriesPoint
 */
export class TimeSeriesPoint extends Message<TimeSeriesPoint> {
  /**
   * @generated from field: string date = 1;
   */
  date = "";

  /**
   * @generated from field: tracker.v1.StatsRow stats = 2;
   */
  stats?: StatsRow;

  constructor(data?: PartialMessage<TimeSeriesPoint>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TimeSeriesPoint";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stats", kind: "message", T: StatsRow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TimeSeriesPoint {
    return new TimeSeriesPoint().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TimeSeriesPoint {
    return new TimeSeriesPoint().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TimeSeriesPoint {
    return new TimeSeriesPoint().fromJsonString(jsonString, options);
  }

  static equals(a: TimeSeriesPoint | PlainMessage<TimeSeriesPoint> | undefined, b: TimeSeriesPoint | PlainMessage<TimeSeriesPoint> | undefined): boolean {
    return proto3.util.equals(TimeSeriesPoint, a, b);
  }
}

/**
 * @generated from message tracker.v1.StatsSortOptions
 */
export class StatsSortOptions extends Message<StatsSortOptions> {
  /**
   * metric_key addresses a metric from the reporting schema (e.g. "clicks",
   * "revenue", "goal.dep.count"). Rows missing the key sort last.
   *
   * @generated from field: string metric_key = 1;
   */
  metricKey = "";

  /**
   * @generated from field: tracker.v1.SortOrder order = 2;
   */
  order = SortOrder.UNSPECIFIED;

  constructor(data?: PartialMessage<StatsSortOptions>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.StatsSortOptions";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "metric_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order", kind: "enum", T: proto3.getEnumType(SortOrder) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StatsSortOptions {
    return new StatsSortOptions().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StatsSortOptions {
    return new StatsSortOptions().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StatsSortOptions {
    return new StatsSortOptions().fromJsonString(jsonString, options);
  }

  static equals(a: StatsSortOptions | PlainMessage<StatsSortOptions> | undefined, b: StatsSortOptions | PlainMessage<StatsSortOptions> | undefined): boolean {
    return proto3.util.equals(StatsSortOptions, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetStreamStatsRequest
 */
export class GetStreamStatsRequest extends Message<GetStreamStatsRequest> {
  /**
   * @generated from field: repeated string stream_ids = 1;
   */
  streamIds: string[] = [];

  /**
   * @generated from field: tracker.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * @generated from field: tracker.v1.AttributionBasis attribution_basis = 3;
   */
  attributionBasis = AttributionBasis.UNSPECIFIED;

  /**
   * metric_keys restricts the returned StatsRow values; empty = all metrics.
   *
   * @generated from field: repeated string metric_keys = 4;
   */
  metricKeys: string[] = [];

  constructor(data?: PartialMessage<GetStreamStatsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetStreamStatsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stream_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
    { no: 3, name: "attribution_basis", kind: "enum", T: proto3.getEnumType(AttributionBasis) },
    { no: 4, name: "metric_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStreamStatsRequest {
    return new GetStreamStatsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStreamStatsRequest {
    return new GetStreamStatsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStreamStatsRequest {
    return new GetStreamStatsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetStreamStatsRequest | PlainMessage<GetStreamStatsRequest> | undefined, b: GetStreamStatsRequest | PlainMessage<GetStreamStatsRequest> | undefined): boolean {
    return proto3.util.equals(GetStreamStatsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetStreamStatsResponse
 */
export class GetStreamStatsResponse extends Message<GetStreamStatsResponse> {
  /**
   * @generated from field: repeated tracker.v1.StreamStatsRow rows = 1;
   */
  rows: StreamStatsRow[] = [];

  constructor(data?: PartialMessage<GetStreamStatsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetStreamStatsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rows", kind: "message", T: StreamStatsRow, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStreamStatsResponse {
    return new GetStreamStatsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStreamStatsResponse {
    return new GetStreamStatsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStreamStatsResponse {
    return new GetStreamStatsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetStreamStatsResponse | PlainMessage<GetStreamStatsResponse> | undefined, b: GetStreamStatsResponse | PlainMessage<GetStreamStatsResponse> | undefined): boolean {
    return proto3.util.equals(GetStreamStatsResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetStreamBreakdownRequest
 */
export class GetStreamBreakdownRequest extends Message<GetStreamBreakdownRequest> {
  /**
   * @generated from field: string stream_id = 1;
   */
  streamId = "";

  /**
   * @generated from field: tracker.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * dimension_key addresses a dimension from the reporting schema
   * (day | country | landing | offer | creative | device | source | node | step | branch).
   *
   * @generated from field: string dimension_key = 3;
   */
  dimensionKey = "";

  /**
   * @generated from field: tracker.v1.Pagination pagination = 4;
   */
  pagination?: Pagination;

  /**
   * @generated from field: optional tracker.v1.StatsSortOptions sort = 5;
   */
  sort?: StatsSortOptions;

  /**
   * @generated from field: optional string dimension_prefix = 6;
   */
  dimensionPrefix?: string;

  /**
   * @generated from field: tracker.v1.AttributionBasis attribution_basis = 7;
   */
  attributionBasis = AttributionBasis.UNSPECIFIED;

  /**
   * metric_keys restricts the returned StatsRow values; empty = all metrics.
   *
   * @generated from field: repeated string metric_keys = 8;
   */
  metricKeys: string[] = [];

  constructor(data?: PartialMessage<GetStreamBreakdownRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetStreamBreakdownRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stream_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
    { no: 3, name: "dimension_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "pagination", kind: "message", T: Pagination },
    { no: 5, name: "sort", kind: "message", T: StatsSortOptions, opt: true },
    { no: 6, name: "dimension_prefix", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "attribution_basis", kind: "enum", T: proto3.getEnumType(AttributionBasis) },
    { no: 8, name: "metric_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStreamBreakdownRequest {
    return new GetStreamBreakdownRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStreamBreakdownRequest {
    return new GetStreamBreakdownRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStreamBreakdownRequest {
    return new GetStreamBreakdownRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetStreamBreakdownRequest | PlainMessage<GetStreamBreakdownRequest> | undefined, b: GetStreamBreakdownRequest | PlainMessage<GetStreamBreakdownRequest> | undefined): boolean {
    return proto3.util.equals(GetStreamBreakdownRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetStreamBreakdownResponse
 */
export class GetStreamBreakdownResponse extends Message<GetStreamBreakdownResponse> {
  /**
   * @generated from field: repeated tracker.v1.BreakdownRow rows = 1;
   */
  rows: BreakdownRow[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  constructor(data?: PartialMessage<GetStreamBreakdownResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetStreamBreakdownResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rows", kind: "message", T: BreakdownRow, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStreamBreakdownResponse {
    return new GetStreamBreakdownResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStreamBreakdownResponse {
    return new GetStreamBreakdownResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStreamBreakdownResponse {
    return new GetStreamBreakdownResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetStreamBreakdownResponse | PlainMessage<GetStreamBreakdownResponse> | undefined, b: GetStreamBreakdownResponse | PlainMessage<GetStreamBreakdownResponse> | undefined): boolean {
    return proto3.util.equals(GetStreamBreakdownResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetMultiBreakdownRequest
 */
export class GetMultiBreakdownRequest extends Message<GetMultiBreakdownRequest> {
  /**
   * @generated from field: repeated string stream_ids = 1;
   */
  streamIds: string[] = [];

  /**
   * @generated from field: tracker.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * @generated from field: string dimension_key = 3;
   */
  dimensionKey = "";

  /**
   * @generated from field: tracker.v1.Pagination pagination = 4;
   */
  pagination?: Pagination;

  /**
   * @generated from field: optional tracker.v1.StatsSortOptions sort = 5;
   */
  sort?: StatsSortOptions;

  /**
   * @generated from field: tracker.v1.AttributionBasis attribution_basis = 6;
   */
  attributionBasis = AttributionBasis.UNSPECIFIED;

  /**
   * metric_keys restricts the returned StatsRow values; empty = all metrics.
   *
   * @generated from field: repeated string metric_keys = 7;
   */
  metricKeys: string[] = [];

  constructor(data?: PartialMessage<GetMultiBreakdownRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetMultiBreakdownRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stream_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
    { no: 3, name: "dimension_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "pagination", kind: "message", T: Pagination },
    { no: 5, name: "sort", kind: "message", T: StatsSortOptions, opt: true },
    { no: 6, name: "attribution_basis", kind: "enum", T: proto3.getEnumType(AttributionBasis) },
    { no: 7, name: "metric_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMultiBreakdownRequest {
    return new GetMultiBreakdownRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMultiBreakdownRequest {
    return new GetMultiBreakdownRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMultiBreakdownRequest {
    return new GetMultiBreakdownRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetMultiBreakdownRequest | PlainMessage<GetMultiBreakdownRequest> | undefined, b: GetMultiBreakdownRequest | PlainMessage<GetMultiBreakdownRequest> | undefined): boolean {
    return proto3.util.equals(GetMultiBreakdownRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetMultiBreakdownResponse
 */
export class GetMultiBreakdownResponse extends Message<GetMultiBreakdownResponse> {
  /**
   * Flattened rows; dimension_value may be prefixed with stream id in implementation.
   *
   * @generated from field: repeated tracker.v1.BreakdownRow rows = 1;
   */
  rows: BreakdownRow[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  constructor(data?: PartialMessage<GetMultiBreakdownResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetMultiBreakdownResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rows", kind: "message", T: BreakdownRow, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMultiBreakdownResponse {
    return new GetMultiBreakdownResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMultiBreakdownResponse {
    return new GetMultiBreakdownResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMultiBreakdownResponse {
    return new GetMultiBreakdownResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetMultiBreakdownResponse | PlainMessage<GetMultiBreakdownResponse> | undefined, b: GetMultiBreakdownResponse | PlainMessage<GetMultiBreakdownResponse> | undefined): boolean {
    return proto3.util.equals(GetMultiBreakdownResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetTimeSeriesRequest
 */
export class GetTimeSeriesRequest extends Message<GetTimeSeriesRequest> {
  /**
   * @generated from field: repeated string stream_ids = 1;
   */
  streamIds: string[] = [];

  /**
   * @generated from field: tracker.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * @generated from field: tracker.v1.TimeSeriesGranularity granularity = 3;
   */
  granularity = TimeSeriesGranularity.UNSPECIFIED;

  /**
   * @generated from field: tracker.v1.AttributionBasis attribution_basis = 4;
   */
  attributionBasis = AttributionBasis.UNSPECIFIED;

  /**
   * metric_keys restricts the returned StatsRow values; empty = all metrics.
   *
   * @generated from field: repeated string metric_keys = 5;
   */
  metricKeys: string[] = [];

  constructor(data?: PartialMessage<GetTimeSeriesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetTimeSeriesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stream_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
    { no: 3, name: "granularity", kind: "enum", T: proto3.getEnumType(TimeSeriesGranularity) },
    { no: 4, name: "attribution_basis", kind: "enum", T: proto3.getEnumType(AttributionBasis) },
    { no: 5, name: "metric_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTimeSeriesRequest {
    return new GetTimeSeriesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTimeSeriesRequest {
    return new GetTimeSeriesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTimeSeriesRequest {
    return new GetTimeSeriesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetTimeSeriesRequest | PlainMessage<GetTimeSeriesRequest> | undefined, b: GetTimeSeriesRequest | PlainMessage<GetTimeSeriesRequest> | undefined): boolean {
    return proto3.util.equals(GetTimeSeriesRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetTimeSeriesResponse
 */
export class GetTimeSeriesResponse extends Message<GetTimeSeriesResponse> {
  /**
   * @generated from field: repeated tracker.v1.TimeSeriesPoint points = 1;
   */
  points: TimeSeriesPoint[] = [];

  constructor(data?: PartialMessage<GetTimeSeriesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetTimeSeriesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "points", kind: "message", T: TimeSeriesPoint, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTimeSeriesResponse {
    return new GetTimeSeriesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTimeSeriesResponse {
    return new GetTimeSeriesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTimeSeriesResponse {
    return new GetTimeSeriesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetTimeSeriesResponse | PlainMessage<GetTimeSeriesResponse> | undefined, b: GetTimeSeriesResponse | PlainMessage<GetTimeSeriesResponse> | undefined): boolean {
    return proto3.util.equals(GetTimeSeriesResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetTopStreamsRequest
 */
export class GetTopStreamsRequest extends Message<GetTopStreamsRequest> {
  /**
   * @generated from field: int32 top_n = 1;
   */
  topN = 0;

  /**
   * metric_key selects the ranking metric from the reporting schema.
   *
   * @generated from field: string metric_key = 2;
   */
  metricKey = "";

  /**
   * @generated from field: tracker.v1.DateRange date_range = 3;
   */
  dateRange?: DateRange;

  /**
   * owner_id narrows to one author's campaigns (a filter, not visibility).
   *
   * @generated from field: optional string owner_id = 5;
   */
  ownerId?: string;

  /**
   * @generated from field: tracker.v1.SortOrder order = 6;
   */
  order = SortOrder.UNSPECIFIED;

  /**
   * metric_keys restricts the returned StatsRow values; empty = all metrics.
   *
   * @generated from field: repeated string metric_keys = 7;
   */
  metricKeys: string[] = [];

  constructor(data?: PartialMessage<GetTopStreamsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetTopStreamsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "top_n", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "metric_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "date_range", kind: "message", T: DateRange },
    { no: 5, name: "owner_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "order", kind: "enum", T: proto3.getEnumType(SortOrder) },
    { no: 7, name: "metric_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTopStreamsRequest {
    return new GetTopStreamsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTopStreamsRequest {
    return new GetTopStreamsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTopStreamsRequest {
    return new GetTopStreamsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetTopStreamsRequest | PlainMessage<GetTopStreamsRequest> | undefined, b: GetTopStreamsRequest | PlainMessage<GetTopStreamsRequest> | undefined): boolean {
    return proto3.util.equals(GetTopStreamsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetTopStreamsResponse
 */
export class GetTopStreamsResponse extends Message<GetTopStreamsResponse> {
  /**
   * @generated from field: repeated tracker.v1.StreamStatsRow rows = 1;
   */
  rows: StreamStatsRow[] = [];

  constructor(data?: PartialMessage<GetTopStreamsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetTopStreamsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rows", kind: "message", T: StreamStatsRow, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTopStreamsResponse {
    return new GetTopStreamsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTopStreamsResponse {
    return new GetTopStreamsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTopStreamsResponse {
    return new GetTopStreamsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetTopStreamsResponse | PlainMessage<GetTopStreamsResponse> | undefined, b: GetTopStreamsResponse | PlainMessage<GetTopStreamsResponse> | undefined): boolean {
    return proto3.util.equals(GetTopStreamsResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.CompareStreamsRequest
 */
export class CompareStreamsRequest extends Message<CompareStreamsRequest> {
  /**
   * @generated from field: string stream_id_a = 1;
   */
  streamIdA = "";

  /**
   * @generated from field: string stream_id_b = 2;
   */
  streamIdB = "";

  /**
   * @generated from field: tracker.v1.DateRange date_range = 3;
   */
  dateRange?: DateRange;

  /**
   * metric_keys restricts the returned StatsRow values; empty = all metrics.
   *
   * @generated from field: repeated string metric_keys = 4;
   */
  metricKeys: string[] = [];

  constructor(data?: PartialMessage<CompareStreamsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CompareStreamsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stream_id_a", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stream_id_b", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "date_range", kind: "message", T: DateRange },
    { no: 4, name: "metric_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompareStreamsRequest {
    return new CompareStreamsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompareStreamsRequest {
    return new CompareStreamsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompareStreamsRequest {
    return new CompareStreamsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CompareStreamsRequest | PlainMessage<CompareStreamsRequest> | undefined, b: CompareStreamsRequest | PlainMessage<CompareStreamsRequest> | undefined): boolean {
    return proto3.util.equals(CompareStreamsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CompareStreamsResponse
 */
export class CompareStreamsResponse extends Message<CompareStreamsResponse> {
  /**
   * @generated from field: tracker.v1.StreamStatsRow stream_a = 1;
   */
  streamA?: StreamStatsRow;

  /**
   * @generated from field: tracker.v1.StreamStatsRow stream_b = 2;
   */
  streamB?: StreamStatsRow;

  /**
   * Aggregate delta as percentage strings keyed by metric key.
   *
   * @generated from field: map<string, string> delta_percent = 3;
   */
  deltaPercent: { [key: string]: string } = {};

  constructor(data?: PartialMessage<CompareStreamsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CompareStreamsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stream_a", kind: "message", T: StreamStatsRow },
    { no: 2, name: "stream_b", kind: "message", T: StreamStatsRow },
    { no: 3, name: "delta_percent", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompareStreamsResponse {
    return new CompareStreamsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompareStreamsResponse {
    return new CompareStreamsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompareStreamsResponse {
    return new CompareStreamsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CompareStreamsResponse | PlainMessage<CompareStreamsResponse> | undefined, b: CompareStreamsResponse | PlainMessage<CompareStreamsResponse> | undefined): boolean {
    return proto3.util.equals(CompareStreamsResponse, a, b);
  }
}

/**
 * ClickFunnelDay holds one day of Keitaro-native click metrics for a campaign.
 *
 * @generated from message tracker.v1.ClickFunnelDay
 */
export class ClickFunnelDay extends Message<ClickFunnelDay> {
  /**
   * @generated from field: string date = 1;
   */
  date = "";

  /**
   * @generated from field: string fb_ad_id = 2;
   */
  fbAdId = "";

  /**
   * @generated from field: int64 tracker_clicks = 3;
   */
  trackerClicks = protoInt64.zero;

  /**
   * @generated from field: int64 unique_clicks = 4;
   */
  uniqueClicks = protoInt64.zero;

  /**
   * bot_rate is approximated as 1 - (unique_clicks / tracker_clicks).
   *
   * @generated from field: double bot_rate = 5;
   */
  botRate = 0;

  /**
   * @generated from field: int64 conversions = 6;
   */
  conversions = protoInt64.zero;

  /**
   * @generated from field: double total_revenue = 7;
   */
  totalRevenue = 0;

  /**
   * @generated from field: double total_cost = 8;
   */
  totalCost = 0;

  constructor(data?: PartialMessage<ClickFunnelDay>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ClickFunnelDay";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "fb_ad_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "tracker_clicks", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "unique_clicks", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "bot_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "conversions", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "total_revenue", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "total_cost", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClickFunnelDay {
    return new ClickFunnelDay().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClickFunnelDay {
    return new ClickFunnelDay().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClickFunnelDay {
    return new ClickFunnelDay().fromJsonString(jsonString, options);
  }

  static equals(a: ClickFunnelDay | PlainMessage<ClickFunnelDay> | undefined, b: ClickFunnelDay | PlainMessage<ClickFunnelDay> | undefined): boolean {
    return proto3.util.equals(ClickFunnelDay, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetClickFunnelRequest
 */
export class GetClickFunnelRequest extends Message<GetClickFunnelRequest> {
  /**
   * @generated from field: string stream_id = 1;
   */
  streamId = "";

  /**
   * @generated from field: tracker.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  constructor(data?: PartialMessage<GetClickFunnelRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetClickFunnelRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stream_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetClickFunnelRequest {
    return new GetClickFunnelRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetClickFunnelRequest {
    return new GetClickFunnelRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetClickFunnelRequest {
    return new GetClickFunnelRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetClickFunnelRequest | PlainMessage<GetClickFunnelRequest> | undefined, b: GetClickFunnelRequest | PlainMessage<GetClickFunnelRequest> | undefined): boolean {
    return proto3.util.equals(GetClickFunnelRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetClickFunnelResponse
 */
export class GetClickFunnelResponse extends Message<GetClickFunnelResponse> {
  /**
   * @generated from field: repeated tracker.v1.ClickFunnelDay rows = 1;
   */
  rows: ClickFunnelDay[] = [];

  /**
   * keitaro_campaign_id is empty when the stream has not been provisioned yet.
   *
   * @generated from field: string keitaro_campaign_id = 2;
   */
  keitaroCampaignId = "";

  /**
   * state indicates availability (AVAILABLE / NOT_PROVISIONED / UNAVAILABLE).
   *
   * @generated from field: tracker.v1.ClickFunnelState state = 3;
   */
  state = ClickFunnelState.UNSPECIFIED;

  /**
   * error_reason is populated when state is UNAVAILABLE.
   *
   * @generated from field: optional string error_reason = 4;
   */
  errorReason?: string;

  constructor(data?: PartialMessage<GetClickFunnelResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetClickFunnelResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rows", kind: "message", T: ClickFunnelDay, repeated: true },
    { no: 2, name: "keitaro_campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "state", kind: "enum", T: proto3.getEnumType(ClickFunnelState) },
    { no: 4, name: "error_reason", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetClickFunnelResponse {
    return new GetClickFunnelResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetClickFunnelResponse {
    return new GetClickFunnelResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetClickFunnelResponse {
    return new GetClickFunnelResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetClickFunnelResponse | PlainMessage<GetClickFunnelResponse> | undefined, b: GetClickFunnelResponse | PlainMessage<GetClickFunnelResponse> | undefined): boolean {
    return proto3.util.equals(GetClickFunnelResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetBreakdownDrilldownRequest
 */
export class GetBreakdownDrilldownRequest extends Message<GetBreakdownDrilldownRequest> {
  /**
   * The campaigns to report on. Empty = every campaign the caller can see —
   * the whole workspace for an admin, with no ceiling on how many.
   *
   * @generated from field: repeated string stream_ids = 1;
   */
  streamIds: string[] = [];

  /**
   * @generated from field: tracker.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * dimension_keys define the nesting order, outermost first (max 4 deep).
   *
   * @generated from field: repeated string dimension_keys = 3;
   */
  dimensionKeys: string[] = [];

  /**
   * @generated from field: tracker.v1.AttributionBasis attribution_basis = 4;
   */
  attributionBasis = AttributionBasis.UNSPECIFIED;

  /**
   * @generated from field: optional tracker.v1.StatsSortOptions sort = 5;
   */
  sort?: StatsSortOptions;

  /**
   * Pages over the top-level groups when with_subtotals is set (a page
   * carries each group's whole subtree), over the rows otherwise.
   *
   * @generated from field: tracker.v1.Pagination pagination = 6;
   */
  pagination?: Pagination;

  /**
   * metric_keys restricts the returned StatsRow values; empty = all metrics.
   *
   * @generated from field: repeated string metric_keys = 7;
   */
  metricKeys: string[] = [];

  /**
   * Narrow every side (clicks, conversions, lander rows) to the rows whose
   * dimension values pass. ANDed.
   *
   * @generated from field: repeated tracker.v1.DimensionFilter dimension_filters = 8;
   */
  dimensionFilters: DimensionFilter[] = [];

  /**
   * HAVING: conditions on computed metrics, ANDed. Tested on every row at
   * every level; a row that fails drops with its subtree.
   *
   * @generated from field: repeated tracker.v1.MetricFilter metric_filters = 9;
   */
  metricFilters: MetricFilter[] = [];

  /**
   * The period to compare with («Сравнить с прошлым»): each row and the
   * totals carry its values for the same group in `compare`.
   *
   * @generated from field: tracker.v1.DateRange compare_range = 10;
   */
  compareRange?: DateRange;

  /**
   * Every level of the nesting, not just the leaves: a parent row is
   * counted by the server like any other row — its uniques are people, not a
   * sum of its children's — and rows come in tree order (a parent, then its
   * children sorted by `sort`).
   *
   * @generated from field: bool with_subtotals = 11;
   */
  withSubtotals = false;

  constructor(data?: PartialMessage<GetBreakdownDrilldownRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetBreakdownDrilldownRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stream_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
    { no: 3, name: "dimension_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "attribution_basis", kind: "enum", T: proto3.getEnumType(AttributionBasis) },
    { no: 5, name: "sort", kind: "message", T: StatsSortOptions, opt: true },
    { no: 6, name: "pagination", kind: "message", T: Pagination },
    { no: 7, name: "metric_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "dimension_filters", kind: "message", T: DimensionFilter, repeated: true },
    { no: 9, name: "metric_filters", kind: "message", T: MetricFilter, repeated: true },
    { no: 10, name: "compare_range", kind: "message", T: DateRange },
    { no: 11, name: "with_subtotals", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBreakdownDrilldownRequest {
    return new GetBreakdownDrilldownRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBreakdownDrilldownRequest {
    return new GetBreakdownDrilldownRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBreakdownDrilldownRequest {
    return new GetBreakdownDrilldownRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBreakdownDrilldownRequest | PlainMessage<GetBreakdownDrilldownRequest> | undefined, b: GetBreakdownDrilldownRequest | PlainMessage<GetBreakdownDrilldownRequest> | undefined): boolean {
    return proto3.util.equals(GetBreakdownDrilldownRequest, a, b);
  }
}

/**
 * DrilldownRow is one bucket of a multi-dimension GROUP BY; the
 * dimension_path entries align positionally with the requested dimensions.
 * A subtotal row's path is shorter than the dimensions (its depth).
 *
 * @generated from message tracker.v1.DrilldownRow
 */
export class DrilldownRow extends Message<DrilldownRow> {
  /**
   * @generated from field: repeated string dimension_path = 1;
   */
  dimensionPath: string[] = [];

  /**
   * @generated from field: tracker.v1.StatsRow stats = 2;
   */
  stats?: StatsRow;

  /**
   * The same group's values over compare_range; unset without one.
   *
   * @generated from field: tracker.v1.StatsRow compare = 3;
   */
  compare?: StatsRow;

  /**
   * «Расход без кликов»: spend that has no visit in the report to land on
   * and whose place in this grouping is unknown (an ad that spent on a day it
   * brought nobody, a manual amount for a day without visits). Its path is
   * "∅" at every level; it carries cost only.
   *
   * @generated from field: bool spend_without_clicks = 4;
   */
  spendWithoutClicks = false;

  constructor(data?: PartialMessage<DrilldownRow>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DrilldownRow";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dimension_path", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "stats", kind: "message", T: StatsRow },
    { no: 3, name: "compare", kind: "message", T: StatsRow },
    { no: 4, name: "spend_without_clicks", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DrilldownRow {
    return new DrilldownRow().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DrilldownRow {
    return new DrilldownRow().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DrilldownRow {
    return new DrilldownRow().fromJsonString(jsonString, options);
  }

  static equals(a: DrilldownRow | PlainMessage<DrilldownRow> | undefined, b: DrilldownRow | PlainMessage<DrilldownRow> | undefined): boolean {
    return proto3.util.equals(DrilldownRow, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetBreakdownDrilldownResponse
 */
export class GetBreakdownDrilldownResponse extends Message<GetBreakdownDrilldownResponse> {
  /**
   * @generated from field: repeated tracker.v1.DrilldownRow rows = 1;
   */
  rows: DrilldownRow[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  /**
   * «Итого»: the whole filtered report counted once by the server (people
   * are uniques of the whole, never a sum of rows).
   *
   * @generated from field: tracker.v1.StatsRow totals = 3;
   */
  totals?: StatsRow;

  /**
   * totals over compare_range.
   *
   * @generated from field: tracker.v1.StatsRow compare_totals = 4;
   */
  compareTotals?: StatsRow;

  constructor(data?: PartialMessage<GetBreakdownDrilldownResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetBreakdownDrilldownResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rows", kind: "message", T: DrilldownRow, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
    { no: 3, name: "totals", kind: "message", T: StatsRow },
    { no: 4, name: "compare_totals", kind: "message", T: StatsRow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBreakdownDrilldownResponse {
    return new GetBreakdownDrilldownResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBreakdownDrilldownResponse {
    return new GetBreakdownDrilldownResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBreakdownDrilldownResponse {
    return new GetBreakdownDrilldownResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBreakdownDrilldownResponse | PlainMessage<GetBreakdownDrilldownResponse> | undefined, b: GetBreakdownDrilldownResponse | PlainMessage<GetBreakdownDrilldownResponse> | undefined): boolean {
    return proto3.util.equals(GetBreakdownDrilldownResponse, a, b);
  }
}

